import styled from '@emotion/styled';
import { IconWrapper } from './OneDriveItemTableRow/utils/FileIconTableCell';
import { FolderOutlined as FileIcon } from '@mui/icons-material';
import stripProps from '@/lib/utils/stripProps';
import type { HTMLTableHeadCellProps } from '@/lib/types';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import { FormattedMessage } from 'react-intl';

const StyledTableHeader = styled('thead')(
  ({ theme }) => ({
    fontWeight: 500,
    backgroundColor: theme.palette.action.hover,
  }),
  addHighContrastStyles(({ theme }) => ({
    borderBottom: `2px solid ${theme.palette.divider}`,
  })),
);

type TableHeaderCellProps = HTMLTableHeadCellProps & {
  columnWidth?: number;
};

const TableHeaderCell = styled(
  stripProps('th', 'columnWidth'),
)<TableHeaderCellProps>(({ columnWidth }) => ({
  width: columnWidth,
  minWidth: columnWidth,
  maxWidth: columnWidth,
}));

const NameHeaderCell = styled(TableHeaderCell)({
  paddingRight: 24,
  minWidth: 120,
});

const FilesTableHeader = () => (
  <StyledTableHeader>
    <tr>
      <TableHeaderCell columnWidth={56} scope="col"></TableHeaderCell>
      <TableHeaderCell columnWidth={36} scope="col">
        <IconWrapper>
          <FileIcon />
        </IconWrapper>
      </TableHeaderCell>
      <NameHeaderCell scope="col">
        <FormattedMessage id="portfolio.challenge.files.add.select.onedrive.file_picker.filesystem.header.columns.name" />
      </NameHeaderCell>
      <TableHeaderCell columnWidth={150} scope="col">
        <FormattedMessage id="portfolio.challenge.files.add.select.onedrive.file_picker.filesystem.header.columns.last_modified" />
      </TableHeaderCell>
      <TableHeaderCell columnWidth={140} scope="col">
        <FormattedMessage id="portfolio.challenge.files.add.select.onedrive.file_picker.filesystem.header.columns.file_size" />
      </TableHeaderCell>
    </tr>
  </StyledTableHeader>
);

export default FilesTableHeader;
